import { replacer } from './session-storage-engine';

export const SESSION_STATE_KEY = 'state';

/** Shape written to sessionStorage before a context-switch reload. */
export function buildPersistedSessionState(
  state: CMx.ApplicationState
): CMx.ApplicationState {
  const {
    cases: { criteriaFilter, sortablePageable, items, roles },
    ...rest
  } = state;

  return {
    cases: {
      criteriaFilter,
      sortablePageable,
      items,
      roles,
      refreshList: true
    },
    ...rest
  };
}

/** Synchronously persist Redux state for reload bootstrap (do not rely on beforeunload). */
export function persistSessionState(state: CMx.ApplicationState): void {
  try {
    const serializedState = JSON.stringify(buildPersistedSessionState(state), replacer);
    window.sessionStorage.setItem(SESSION_STATE_KEY, serializedState);
  } catch (err) {
    console.error('persistSessionState failed', err);
  }
}
